import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Delete, Edit } from "@mui/icons-material";
import useAuthStore from "../../../services/AuthStore";

export default function Subjects() {
  const { getSubjects } = useAuthStore();
  const [subjects, setSubjects] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [currentSubject, setCurrentSubject] = useState({
    id: null,
    subject_name: "",
    teachers_id: [],
  });
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    getSubjects()
      .then(newSubjects => {
        setSubjects(newSubjects);
      })
      .catch(error => {
        console.error("Ошибка при получении групп:", error);
      });
  }, [getSubjects]);

  const handleOpenDialog = (
    subject = { id: null, subject_name: "", teachers_id: [] },
  ) => {
    setCurrentSubject(subject);
    setIsEditing(!!subject.id);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setCurrentSubject({ id: null, subject_name: "", teachers_id: [] });
  };

  const handleSaveSubject = () => {
    if (isEditing) {
      setSubjects(prev =>
        prev.map(subject =>
          subject.id === currentSubject.id ? currentSubject : subject,
        ),
      );
    } else {
      setSubjects(prev => [
        ...prev,
        {
          ...currentSubject,
          id: prev.length ? prev[prev.length - 1].id + 1 : 1,
        },
      ]);
    }
    handleCloseDialog();
  };

  const handleDeleteSubject = id => {
    setSubjects(prev => prev.filter(subject => subject.id !== id));
  };

  const columns = [
    { field: "id", headerName: "Номер", width: 90 },
    { field: "subject_name", headerName: "Название предмета", width: 200 },
    {
      field: "teachers_id",
      headerName: "ID Учителей",
      width: 200,
      renderCell: params => params.value.join(", "),
    },
    {
      field: "actions",
      headerName: "Действия",
      width: 200,
      renderCell: params => (
        <Box>
          <Button
            size="small"
            variant="contained"
            onClick={() => handleOpenDialog(params.row)}>
            <Edit />
          </Button>
          <Button
            size="small"
            color="error"
            variant="contained"
            onClick={() => handleDeleteSubject(params.row.id)}
            style={{ marginLeft: 8 }}>
            <Delete />
          </Button>
        </Box>
      ),
    },
  ];

  return (
    <Box>
      <Typography variant="h6" style={{ marginBottom: 16 }}>
        Управление предметами
      </Typography>
      <Button
        variant="contained"
        onClick={() => handleOpenDialog()}
        style={{ marginBottom: 16 }}>
        Добавить новый предмет
      </Button>
      <Box sx={{ height: 400, width: "100%" }}>
        <DataGrid
          rows={subjects}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5]}
        />
      </Box>

      <Dialog open={dialogOpen} onClose={handleCloseDialog}>
        <DialogTitle>{isEditing ? "Edit Subject" : "Add Subject"}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Название предмета"
            fullWidth
            value={currentSubject.subject_name}
            onChange={e =>
              setCurrentSubject({
                ...currentSubject,
                subject_name: e.target.value,
              })
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleSaveSubject} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
